<template>
  <AppLayoutContainerSmall class="archive-teasers-block" :md-wide="true">
    <h2 v-if="data.title"
        class="archive-teasers-block__title">
      {{ data.title }}</h2>
    <ol class="archive-teasers-block__list">
      <li class="archive-teasers-block__item" v-for="(article, index) in data.articles"
          :key="`archive-teaser-item_${index}`">
        <AppContentItem
            label="Bekijk de pagina"
            :data="article.articles_id"
            :basePath="/archive/"
        />
      </li>
    </ol>
  </AppLayoutContainerSmall>
</template>

<script setup lang="ts">

import {TArchiveTeasersBlock} from "~/types/block-archive-types";

const props = defineProps<{
  data: TArchiveTeasersBlock
}>()
</script>

<style scoped lang="postcss">
.archive-teasers-block {
  &__title {
    margin-bottom: 0.5rem;
    text-align: center;
    @mixin heading-h2-midnight;

    @media (--md) {
      margin-bottom: 1rem;
    }
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  &__item {
    margin-bottom: 0.5rem;
  }
}
</style>
